import { useState, useCallback } from 'react';
import { click as clickAPI, APIError } from '../services/api';

/**
 * Custom Hook: useClickTracking
 * Handles button click tracking
 * 
 * Usage:
 * const { trackClick, isTracking } = useClickTracking();
 */
export function useClickTracking() {
  const [isTracking, setIsTracking] = useState(false);
  const [lastError, setLastError] = useState('');

  const trackClick = useCallback(async (product) => {
    setIsTracking(true);
    setLastError('');

    try {
      await clickAPI.track(product);
      console.log(`✓ Click tracked: ${product}`);
    } catch (err) {
      if (err instanceof APIError) {
        setLastError(err.message);
        console.error('Click tracking error:', err.message);
      } else {
        console.error('Click tracking error:', err);
      }
    } finally {
      setIsTracking(false);
    }
  }, []);

  return { trackClick, isTracking, lastError };
}
